'use client'

const defaultProps = {
  variant: "body.base",
  color: "onLight.text.primary",
  as: "span"
};
export {
  defaultProps
};
